import { render, staticRenderFns } from "./ProfileIdentVolunteerFormNet.vue?vue&type=template&id=af73c2ce"
import script from "./ProfileIdentVolunteerFormNet.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentVolunteerFormNet.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentVolunteerFormNet.vue?vue&type=style&index=0&id=af73c2ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports